import React from 'react'
import './preset-modal-content.scss'

import { PrimeButton } from 'components-design-system'

const DeletePresetSuccess = ({
  setOpenModal
}) => {
  return <div className="preset-modal-content">
    <div className="actions">
      <PrimeButton
        type="primary"
        size="large"
        onClick={() => setOpenModal(false)}>
        Okay
      </PrimeButton>
    </div>
  </div>
}

export default DeletePresetSuccess